import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  onConfirm: () => void
}

export const ResetTradingAccountPasswordModal: BaseModalType<Props> = ({ close, onConfirm }) => {
  const { t } = useTranslation()
  return (
    <Modal>
      <Modal.Header>{t('Trading Account.We will reset your password')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t(
            'Trading Account.The system will generate a new account password and send it via email. Do you want to proceed'
          )}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={onConfirm}>
          {t('Trading Account.Yes, reset password')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
